import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloLink } from 'apollo-link'
import { setContext } from 'apollo-link-context'
import { createUploadLink } from 'apollo-upload-client'

const graphqlEndpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT
const cache = new InMemoryCache()

// persistCache({
//   cache,
//   storage: AsyncStorage
// })

const authLink = setContext(async (req, { headers }) => {
  const token = await localStorage.getItem('user-token')

  return {
    ...headers,
    headers: {
      Authorization: token ? `Bearer ${token}` : null
    }
  }
})

const uploadLink = createUploadLink({
  uri: graphqlEndpoint
})

const client = new ApolloClient({
  link: ApolloLink.from([authLink, uploadLink]),
  cache
})

export default client



// WEBPACK FOOTER //
// ./src/graphql/index.js